import {
    Avatar,
    HStack,
    IconButton,
    Popover,
    PopoverTrigger,
    Tooltip,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { MdFileCopy } from 'react-icons/md';
import { useSelector } from 'react-redux';

import Text from 'components/v4/Text';
import { AvatarPopoverContent } from 'pages/accounts/users/new/cellRenderer/AvatarPopoverContent';

import { iconStyling } from '../../../../../components/tables/AGGrid/agGridStyles';
import useCellHover from '../../../../../components/tables/AGGrid/hooks/useCellHover';

const DisplayNameRenderer = ({ value, valueFormatted, data }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const { isHovered, containerRef } = useCellHover();
    const initialFocusRef = useRef();
    const formattedValue = valueFormatted ?? value;
    const isRingGroup =
        data?.primaryUser?.userType === 'RingGroup' ||
        data?.userType === 'RingGroup';
    const isRA =
        data?.primaryUser?.userType === 'ResourceAccount' ||
        data?.userType === 'ResourceAccount' ||
        isRingGroup;
    const bg = isRA ? 'white' : '#007BFF';
    const color = isRA ? '#007BFF' : 'white';
    const borderColor = isRA ? '#007BFF' : null;
    const popoverBgStyle = darkMode ? 'dark.bgDarkGray' : 'white';

    return (
        <HStack ref={containerRef} width="100%" overflow="hidden">
            <Popover
                trigger="hover"
                placement="bottom-start"
                initialFocusRef={initialFocusRef}>
                <PopoverTrigger>
                    <Avatar
                        size="sm"
                        name={formattedValue}
                        bg={bg}
                        color={color}
                        borderColor={borderColor}
                        showBorder
                        borderWidth="1px"
                    />
                </PopoverTrigger>
                {isHovered && (
                    <AvatarPopoverContent
                        darkMode={darkMode}
                        bg={popoverBgStyle}
                        isRA={isRA}
                        isRingGroup={isRingGroup}
                    />
                )}
            </Popover>
            <Text
                isTruncated
                flex="1"
                minWidth="0"
                overflow="hidden"
                color={darkMode ? 'white' : 'gray.800'}>
                {formattedValue}
            </Text>
            {isHovered && (
                <Tooltip label="Copy to clipboard">
                    <IconButton
                        sx={{
                            ...iconStyling,
                            pointerEvents: 'auto',
                        }}
                        size="sm"
                        variant="ghost"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(formattedValue);
                        }}>
                        <MdFileCopy />
                    </IconButton>
                </Tooltip>
            )}
        </HStack>
    );
};

export default DisplayNameRenderer;
